module.exports = __webpack_public_path__ + "img/un.d3a2dec6.svg";